import { get, post, put } from '../../../helpers/api'
import { api } from '../api'
import * as T from 'src/store/types'
import helpers from 'src/helpers'
import _ from 'lodash'
import querystring from 'querystring'

export const getSalesListAction = async ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    post(api.salesListing, _.pickBy(query, _.identity)).then(response => {
      const json = response.data
      commit(T.SET_SALES_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getEligibleSaleSearchAction = async ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    post(api.salesListing, query).then(response => {
      const json = response.data.data
      commit(T.SET_SALE_ELIGIBLE_TRANSFER_SEARCH, {
        list: json.map(opt => ({
          label: `${opt.document_number}`,
          value: opt.id,
          userID: opt.user_id,
          sublabel: `${opt.invoices.invoice_number} (${helpers.getValue(opt, 'invoices.invoice_date', '')})`,
          data: opt,
        })),
      })

      resolve(response)
    })
  })
}

export const getDownlineValidationAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.downlineValidation, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getClassicCheckAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.classicCheck, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getSalesProductSearchAction = async ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    post(api.salesProductSearch, query).then(response => {
      const json = response.data
      commit(T.SET_SALES_PRODUCTS_LIST_DATA, {
        data: json,
      })
      resolve(response.data)
    })
  })
}

export const getSalesInvoiceSearchAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.taxInvoiceSearch, query)
      .then(response => {
        const json = response.data.data
        commit(T.SET_SALES_INVOICE_LIST_DATA, {
          list: {
            data: json.map(opt => ({
              label: opt.invoice_number,
              value: opt.id,
              sublabel: opt.invoice_date,
              transactionDate: opt.invoice_date,
              userID: opt.sale.user_id,
            })),
            total: response.data.total,
          },
        })
        const json2 = response.data
        commit(T.SET_TAX_INVOICE_LISTING, {
          list: json2,
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getSalesInvoiceDetail = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.taxInvoiceDetail, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getSalesProductEligibleAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.salesProductEligible, query)
      .then(response => {
        const json = response.data
        if (
          json.workflow !== null &&
          json.workflow !== undefined &&
          json.sales_data !== null &&
          json.sales_data !== undefined
        ) {
          json.sales_data.workflow = json.workflow
        }
        commit(T.SET_SALES_DATA, {
          data: json.sales_data,
        })
        if (helpers.isSet(response, 'data.error_msg', ['notNull', 'notEmpty'])) {
          let errorMsg = helpers.getValue(response, 'data.error_msg')
          commit(T.SET_SALE_ELIGIBLE_ERROR, errorMsg)
        } else {
          commit(T.SET_SALE_ELIGIBLE_ERROR, false)
        }
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getSalesCancellationInvoiceDetailAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.salesCancellationInvoiceDetailSearch, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const createUpdateSalesCancellation = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.salesCancellationCreation, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getSalesCancellationSearchAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.salesCancellationListingSearch, query).then(response => {
      const json = response.data
      commit(T.SET_ORDER_CANCELLATION_SEARCH_LIST, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getSalesCancellationDetail = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.salesCancellationDetail, query).then(response => {
      resolve(response.data)
    })
  })
}

export const downloadTaxInvoicePDF = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.retrieveTaxInvoicePDF, query).then(response => {
      resolve(response.data)
    })
  })
}

export const downloadCreditNotePDF = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.retrieveCreditNotePDF, query).then(response => {
      resolve(response.data)
    })
  })
}

export const postSalesAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.sales, query)
      .then(response => {
        const json = response.data
        if (
          json.workflow !== null &&
          json.workflow !== undefined &&
          json.sales_data !== null &&
          json.sales_data !== undefined
        ) {
          json.sales_data.workflow = json.workflow
        }
        commit(T.SET_SALES_DATA, {
          data: json.sales_data,
        })
        commit(T.SHOW_NOTIFICATION, {
          title: 'Sales creation',
          message: window.il8n.t('operation.success'),
          type: 'positive',
        })
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getSalesDataAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.salesDetails, query)
      .then(response => {
        const json = response.data
        if (
          json.workflow !== null &&
          json.workflow !== undefined &&
          json.sales_data !== null &&
          json.sales_data !== undefined
        ) {
          json.sales_data.workflow = json.workflow
        }
        commit(T.SET_SALES_DATA, {
          data: json.sales_data,
        })
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getPaymentModesAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.paymentModes, query).then(response => {
      const json = response.data
      commit(T.SET_PAYMENT_OPTIONS, {
        list: json,
      })
      resolve(response)
    })
  })
}

export const makePaymentAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.makePayment, query)
      .then(response => {
        commit(T.SHOW_NOTIFICATION, {
          title: 'Payment',
          message: window.il8n.t('operation.success'),
          type: 'positive',
        })
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getProductExchangeSearchAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.productExchangeListingSearch, query).then(response => {
      const json = response.data
      commit(T.SET_PRODUCT_EXCHANGE_SEARCH_LIST, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const postProductExchangeCreationAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.productExchangeCreation, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getProductExchangeDetailAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.productExchangeDetail, query).then(response => {
      const json = response.data
      commit(T.SET_SALES_EXCHANGE_DATA, {
        data: json.sales_exchange_data,
      })
      resolve(response.data)
    })
  })
}

export const salesCancellationBatchProcessRefund = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.cancellationBatchProcessRefund, query).then(response => {
      resolve(response.data)
    })
  })
}

export const downloadExchangeBillPDF = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.retriveExchangeBillPDF, query).then(response => {
      resolve(response.data)
    })
  })
}

export const putSalesAction = ({ commit }, query) => {
  return new Promise(resolve => {
    put(api.sales + '/' + query.sales_data.sale_id, query).then(response => {
      const json = response.data
      commit(T.SET_SALES_DATA, {
        data: json.sales_data,
      })
      commit(T.SHOW_NOTIFICATION, {
        title: 'Sales update',
        message: window.il8n.t('operation.success'),
        type: 'positive',
      })
      resolve(response)
    })
  })
}

export const createUpdateLegacySalesCancellation = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.legacySalesCancellationCreation, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getAeonPaymentListingSearchAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.aeonPaymentList, query).then(response => {
      const json = response.data
      commit(T.SET_AEON_SEARCH_LIST, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const aeonPaymentBatchReleaseAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.aeonBatchRelease, query).then(response => {
      commit(T.SHOW_NOTIFICATION, {
        title: 'Aeon Payment Batch Release',
        message: window.il8n.t('operation.success'),
        type: 'positive',
      })
      resolve(response.data)
    })
  })
}

export const getEppPaymentListSearchAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.eppPaymentList, query).then(response => {
      const json = response.data
      commit(T.SET_EPP_SEARCH_LIST, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getDailySalesReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.dailySalesReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const submitEppApprovalAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.submitEppApproval, query).then(response => {
      commit(T.SET_EPP_MOTO_APPROVAL_RESPONSE_DATA, response.data)
      commit(T.SHOW_NOTIFICATION, {
        title: 'Approval Code',
        message: window.il8n.t('operation.success'),
        type: 'positive',
      })
      resolve(response.data)
    })
  })
}

export const submitAeonAgreementNumberAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.submitAeonAgreementNumber, query)
      .then(response => {
        commit(T.SHOW_NOTIFICATION, {
          title: 'Aeon Agreement Number',
          message: window.il8n.t('operation.success'),
          type: 'positive',
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const downloadPreOderNote = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.downloadPreOrderNote, query).then(response => {
      resolve(response.data)
    })
  })
}

export const batchCancelPaymentAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.batchCancelPayment, query).then(response => {
      commit(T.SET_EPP_MOTO_REJECTION_RESPONSE_DATA, response.data)
      resolve(response.data)
    })
  })
}

export const convertEppMotoSalesOrderAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.convertEppMotoSales, query).then(response => {
      resolve(response.data)
    })
  })
}

export const downloadAmpInvoice = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.downloadAmpInvoice, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getEnrollmentTypeByCountryAction = ({ commit }, countryID = '') => {
  return new Promise(resolve => {
    get(api.enrollmentTypeByCountry + countryID).then(response => {
      commit(T.SET_BACK_OFFICE_ENROLLMENT_TYPE, response.data)
      resolve(response.data)
    })
  })
}

export const getEnrollmentSalesProductSearchAction = async ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    post(api.enrollmentProductKittingSearch, query).then(response => {
      if (response !== undefined) {
        const json = response.data
        commit(T.SET_SALES_PRODUCTS_LIST_DATA, {
          data: json,
        })
        resolve(response.data)
      } else {
        resolve()
      }
    })
  })
}

export const submitEnrollmentRequestAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.submitBackOfficeEnrollment, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getAllEnrollmentRankListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.getEnrollmentRankList, query).then(response => {
      const json = response.data
      commit(T.SET_BACK_OFFICE_ENROLLMENT_RANK, {
        data: json,
      })
      resolve(response.data)
    })
  })
}

export const getEnrollmentTempDataAction = ({ commit }, saleId) => {
  return new Promise((resolve, reject) => {
    get(api.getEnrollmentSalesTempData + saleId)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const submitAgentCodeAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.updateAeonAgentCode, query)
      .then(response => {
        commit(T.SHOW_NOTIFICATION, {
          title: 'Agent Code',
          message: window.il8n.t('operation.success'),
          type: 'positive',
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const rentalSalesUpdatePreScreeningStatusAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.rentalSalesPreScreeningStatusUpdate, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const rentalSalesUpdateCredibilityCheckStatusAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.rentalSalesCredibilityStatusUpdate, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const rentalSalesConvertSalesAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.rentalSalesConvertSales, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const putRMSSalesNumberAction = ({ commit }, query) => {
  return new Promise(resolve => {
    put(api.rentalSalesRMSSalesNumberUpdate + '/' + query.sale_id, query).then(response => {
      let json = response.data
      commit(T.SET_SALES_DATA, {
        data: json.sales_data,
      })
      resolve(response.data)
    })
  })
}

export const getPaymentQRCodeAction = ({ commit }, paymentID) => {
  return new Promise(resolve => {
    get(api.paymentQRCode + paymentID).then(response => {
      resolve(response.data)
    })
  })
}

export const submitTransferSaleAction = async ({ commit, dispatch }, query) => {
  return new Promise((resolve, reject) => {
    post(api.salesTransfer, query)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getSvMonthAmendmentListAction = async ({ commit }, payload) => {
  let query = '?' + querystring.stringify(_.pickBy(payload, _.identity))
  return new Promise(resolve => {
    get(api.svMonthAmendmentListing + query).then(response => {
      resolve(response.data)
    })
  })
}

export const getSvMonthAmendmentDetailsAction = async ({ commit }, recordID) => {
  return new Promise((resolve, reject) => {
    get(api.svMonthAmendmentDetails + recordID)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const submitSvMonthAmendmentAction = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    post(api.svMonthAmendmentCreation, payload)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getSalesSvTransferByProductListAction = async ({ commit }, payload) => {
  return new Promise(resolve => {
    get(api.svTransferByProduct + payload).then(response => {
      resolve(response.data)
    })
  })
}

export const getSalesSvTransferByProductDetailsByIdAction = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    let { id } = payload
    get(api.svTransferByProduct + '/' + id, payload)
      .then(response => {
        commit(T.SET_SV_TRANSFER_BY_PRODUCT_FORM_DATA, response.data.data)
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const submitSalesSvTransferByProductAction = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    post(api.svTransferByProduct, payload)
      .then(response => {
        commit(T.SET_SV_TRANSFER_BY_PRODUCT_FORM_DATA, response.data.data)
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getSalesSvTransferByProductItemsListAction = async ({ commit }, payload) => {
  let query = '?' + querystring.stringify(_.pickBy(payload, _.identity))
  return new Promise(resolve => {
    get(api.svTransferByProductItems + query).then(response => {
      commit(T.SET_SALE_SV_TRANSFER_BY_PRODUCT_ITEMS, response.data)
      resolve(response.data)
    })
  })
}

export const resetSalesSvTransferByProductDataAction = async ({ commit }) => {
  commit(T.SET_SALE_SV_TRANSFER_BY_PRODUCT_ITEMS, {})
}

export const submitExpressEnrollmentAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    post(api.submitBackOfficeEnrollment, payload).then(response => {
      const json = response.data
      commit(T.SHOW_NOTIFICATION, {
        title: 'Enrollment Creation Success',
        message: window.il8n.t('operation.success'),
        type: 'positive',
      })
      resolve(json)
    })
  })
}
